import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  client: {},
  clients: [],
  clientPagination: {},
  loader: false,
  loading: false,
  overviewLoader: false,
  error: "",
  portfolio: {},
  portfolios: [],
  portfoliosPagination: {},
  resources: [],
  resourcesPagination: {},
  communicationPlan: [],
  communicationLoading: false,
  communicationPlanPagination: {},
  programs: [],
  programsLoading: false,
  programsPagination: {},
});

export default function clientReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CLIENTS.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.CLIENTS.SUCCESS: {
      return state
        .set("error", "")
        .set("clients", action.data.data)
        .set("clientPagination", action.data.pagination)
        .set("loading", false);
    }
    case ACTIONS.CLIENTS.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    case ACTIONS.SORT_CLIENTS.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_CLIENTS.SUCCESS: {
      return state
        .set("error", "")
        .set("clients", action.data.data)
        .set("clientPagination", action.data.pagination);
    }
    case ACTIONS.SORT_CLIENTS.ERROR: {
      return state.set("error", action.error);
    }

    // CREATE CLIENT
    case ACTIONS.CREATE_CLIENT.PENDING: {
      return state.set("error", "").set("loader", true);
    }
    case ACTIONS.CREATE_CLIENT.SUCCESS: {
      return state
        .set("error", "")
        .set("loader", false)
        .set("clients", action.data.data)
        .set("clientPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_CLIENT.ERROR: {
      return state.set("error", action.error).set("loader", false);
    }

    // UPDATE CLIENT
    case ACTIONS.UPDATE_CLIENT.PENDING: {
      return state.set("error", "").set("loader", true);
    }
    case ACTIONS.UPDATE_CLIENT.SUCCESS: {
      if (action.data.type === "overview") {
        return state
          .set("error", "")
          .set("loader", false)
          .set("client", action.data.data);
      } else {
        return state
          .set("error", "")
          .set("loader", false)
          .set("clients", action.data.data)
          .set("clientPagination", action.data.pagination);
      }
      // return state.set('error', '').set('loader', false).set('clients', action.data.data).set('clientPagination', action.data.pagination);
    }
    case ACTIONS.UPDATE_CLIENT.ERROR: {
      return state.set("error", action.error).set("loader", false);
    }

    // DELETE CLIENT
    case ACTIONS.DELETE_CLIENT.PENDING: {
      return state.set("error", "").set("loader", true);
    }
    case ACTIONS.DELETE_CLIENT.SUCCESS: {
      return state
        .set("error", "")
        .set("loader", false)
        .set("clients", action.data.data)
        .set("clientPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_CLIENT.ERROR: {
      return state.set("error", action.error).set("loader", false);
    }

    // GET CLIENT DETAILS
    case ACTIONS.GET_CLIENT_DETAILS.PENDING: {
      return state
        .set("error", "")
        .set("loader", true)
        .set("overviewLoader", true);
    }
    case ACTIONS.GET_CLIENT_DETAILS.SUCCESS: {
      return state
        .set("error", "")
        .set("loader", false)
        .set("overviewLoader", false)
        .set("client", action.data);
    }
    case ACTIONS.GET_CLIENT_DETAILS.ERROR: {
      return state
        .set("error", action.error)
        .set("loader", false)
        .set("overviewLoader", false);
    }

    ///////////////////////////////////////////////// PORTFOLIOS /////////////////////////////////////////////////

    case ACTIONS.CLIENT_PORTFOLIOS.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.CLIENT_PORTFOLIOS.SUCCESS: {
      return state
        .set("error", "")
        .set("portfolios", action.data.data)
        .set("portfoliosPagination", action.data.pagination)
        .set("loading", false);
    }
    case ACTIONS.CLIENT_PORTFOLIOS.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    case ACTIONS.SORT_CLIENT_PORTFOLIOS.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_CLIENT_PORTFOLIOS.SUCCESS: {
      return state
        .set("error", "")
        .set("portfolios", action.data.data)
        .set("portfoliosPagination", action.data.pagination);
    }
    case ACTIONS.SORT_CLIENT_PORTFOLIOS.ERROR: {
      return state.set("error", action.error);
    }

    case ACTIONS.CREATE_CLIENT_PORTFOLIOS.PENDING: {
      return state.set("error", "").set("loader", true);
    }
    case ACTIONS.CREATE_CLIENT_PORTFOLIOS.SUCCESS: {
      return state
        .set("error", "")
        .set("loader", false)
        .set("portfolios", action.data.data)
        .set("portfoliosPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_CLIENT_PORTFOLIOS.ERROR: {
      return state.set("error", action.error);
    }

    case ACTIONS.UPDATE_CLIENT_PORTFOLIOS.PENDING: {
      return state.set("error", "").set("loader", true);
    }
    case ACTIONS.UPDATE_CLIENT_PORTFOLIOS.SUCCESS: {
      return state
        .set("error", "")
        .set("loader", false)
        .set("portfolios", action.data.data)
        .set("portfoliosPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_CLIENT_PORTFOLIOS.ERROR: {
      return state.set("error", action.error);
    }

    case ACTIONS.DELETE_CLIENT_PORTFOLIOS.PENDING: {
      return state.set("error", "").set("loader", true);
    }
    case ACTIONS.DELETE_CLIENT_PORTFOLIOS.SUCCESS: {
      return state
        .set("error", "")
        .set("loader", false)
        .set("portfolios", action.data.data)
        .set("portfoliosPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_CLIENT_PORTFOLIOS.ERROR: {
      return state.set("error", action.error);
    }

    ///////////////////////////////////////////////// ALLOCATED RESOURCES /////////////////////////////////////////////////

    case ACTIONS.CLIENT_RESOURCES.PENDING: {
      return state.set("error", "").set("loading", true);
    }
    case ACTIONS.CLIENT_RESOURCES.SUCCESS: {
      return state
        .set("error", "")
        .set("resources", action.data.data)
        .set("resourcesPagination", action.data.pagination)
        .set("loading", false);
    }
    case ACTIONS.CLIENT_RESOURCES.ERROR: {
      return state.set("error", action.error).set("loading", false);
    }

    case ACTIONS.SORT_CLIENT_RESOURCES.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_CLIENT_RESOURCES.SUCCESS: {
      return state
        .set("error", "")
        .set("resources", action.data.data)
        .set("resourcesPagination", action.data.pagination);
    }
    case ACTIONS.SORT_CLIENT_RESOURCES.ERROR: {
      return state.set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
